<template>
    <div class="cst-survey-lng-switch">
        <div v-for="(entry, i) in availableLanguages" :key="entry" :class="{ selected: entry==currentLocale }">
            <a href="#" @click.prevent="setLocale(entry)">
              {{ entry | uppercase }}
            </a>
            <span v-if="i < availableLanguages.length -1">|</span>
        </div>
    </div>
</template>

<script>
    export default {
      data: function () {
        return {
        }
      },
      computed: {
        currentLocale: function () {
          return this.$store.state.locale
        },
        availableLanguages: function () {
          return this.$store.state.hotelData.hotel.languages
        }
      },
      methods: {
        setLocale: function (locale) {
          this.$store.dispatch('setLocale', locale)
        }
      },
      filters: {
        uppercase: function (value) {
          return value.toUpperCase()
        }
      }
    }
</script>

<style lang="less" scoped>
    @import '../_theme';

    .cst-survey-lng-switch {
        box-sizing: border-box;
        display: flex;
        margin-right: 2px;
    }
    .cst-survey-lng-switch div {
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .cst-survey-lng-switch a {
      padding: 3px;
      margin: 3px;
      height: 27px;
      width: 27px;
      text-align: center;
      text-decoration: none;
      color: #888;
      opacity: 0.8;
    }
    .cst-survey-lng-switch span {
      color: #888;
      opacity: 0.8;
    }
    .cst-survey-lng-switch div.selected {
        display: none;
    }
</style>


// WEBPACK FOOTER //
// src/components/AppLngSwitch.vue